module.exports = __webpack_public_path__ + "static/media/Políticas de calidad.078a3edf.pdf";